import { render, staticRenderFns } from "./ShowLanguageSelect.vue?vue&type=template&id=586e41a4"
import script from "./ShowLanguageSelect.vue?vue&type=script&lang=js"
export * from "./ShowLanguageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports